import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// ====== Import schemas from generated ======
const {
  SpendingCategoryFirestoreResponse,
  CreateSpendingCategoryDto,
  UpdateSpendingCategoryDto,
  DeleteSpendingCategoryResponseDto,
} = schemas;

// ====== Re-export schemas for external use ======
export const SpendingCategoryResponseSchema = SpendingCategoryFirestoreResponse;
export const CreateSpendingCategorySchema = CreateSpendingCategoryDto;
export const UpdateSpendingCategorySchema = UpdateSpendingCategoryDto;

// ====== Type Exports ======
export type SpendingCategoryResponse = z.infer<typeof SpendingCategoryFirestoreResponse>;
export type CreateSpendingCategory = z.infer<typeof CreateSpendingCategoryDto>;
export type UpdateSpendingCategory = z.infer<typeof UpdateSpendingCategoryDto>;

// API factory function
export function createSpendingCategoriesApi(client: TypedApiClient) {
  return {
    getSpendingCategories: (): Promise<SpendingCategoryResponse[]> => {
      return client.get('/spending-categories', {
        responseSchema: z.array(SpendingCategoryFirestoreResponse),
      });
    },

    createSpendingCategory: (data: CreateSpendingCategory): Promise<SpendingCategoryResponse> => {
      return client.post('/spending-categories', {
        data,
        requestSchema: CreateSpendingCategoryDto,
        responseSchema: SpendingCategoryFirestoreResponse,
      });
    },

    updateSpendingCategory: (id: string, data: UpdateSpendingCategory): Promise<SpendingCategoryResponse> => {
      return client.patch(apiPath`/spending-categories/${id}`, {
        data,
        requestSchema: UpdateSpendingCategoryDto,
        responseSchema: SpendingCategoryFirestoreResponse,
      });
    },

    deleteSpendingCategory: (id: string): Promise<z.infer<typeof DeleteSpendingCategoryResponseDto>> => {
      return client.delete(apiPath`/spending-categories/${id}`, {
        responseSchema: DeleteSpendingCategoryResponseDto,
      });
    },
  };
}
